//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"SourceDescendantOptions",1,0],[1,"SourceObjects",0,"SelectNXObjectList",0],[1,"TargetObject",0,"SelectNXObject",0]],[[["assignObjects"],"Assign",{},1,0],[["unassignObjects"],"Unassign",{},1,0],[["numOfObjects","automationRelatedObjects"],"CollectAutomationRelatedObjects",{},0,0]],[]];
SPLM.AME.AutomationControlScopeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.AutomationControlScopeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.AutomationControlScopeBuilder.Aspect = Object.freeze({
    "Function" : "Function", "Location" : "Location", "Product" : "Product", "Automation" : "Automation", "None" : "None"});

export default SPLM;